import axios from "axios";
import React, { Component, useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { CSSTransition } from "react-transition-group";
import Swal from "sweetalert2";
import DashNavbar from "./DashNavbar";
import Sidebar from "./Sidebar";
import "../css/admindash.css";
import DataTable from "react-data-table-component";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
} from "chart.js";
import CanvasJSReact from "@canvasjs/react-charts";
import { FiUsers } from "react-icons/fi";
import { ImUserTie } from "react-icons/im";
import { AiOutlineSchedule } from "react-icons/ai";
import { MdWork } from "react-icons/md";
import { HiMiniUserGroup } from "react-icons/hi2";
import { FaUserCheck, FaUserTie } from "react-icons/fa";
import { FaChalkboardUser, FaUserXmark } from "react-icons/fa6";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { SlCalender } from "react-icons/sl";
import { ImSearch } from "react-icons/im";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import { ClipLoader } from "react-spinners";
import { FaSearch } from "react-icons/fa";
import { FaHardHat, FaBriefcase } from "react-icons/fa";
import { FaEnvelope, FaFileContract } from "react-icons/fa"; // New icons for letters

ChartJS.register(LineElement, PointElement, LinearScale, Title, CategoryScale);
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const UserLineChart = () => {
  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://raasbackend.vetrinahealthcare.com/student"
        );
        const data = response.data;

        // Group the data by date and count the number of users
        const groupedData = data.reduce((acc, curr) => {
          const date = curr.created_at.split("T")[0];
          if (acc[date]) {
            acc[date].count += 1;
          } else {
            acc[date] = { date, count: 1 };
          }
          return acc;
        }, {});

        // Convert the grouped data to an array
        const chartData = Object.values(groupedData);

        setUserData(chartData);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchData();
  }, []);

  const chartData = {
    labels: userData.map((data) => data.date),
    datasets: [
      {
        label: "Number of Users",
        data: userData.map((data) => data.count),
        borderColor: "rgb(75, 192, 192)",
        backgroundColor: "rgba(0, 0, 0, 0)",
        borderWidth: 2,
        pointBackgroundColor: "rgba(75, 192, 192, 1)",
        pointBorderColor: "rgba(75, 192, 192, 1)",
        pointHoverBackgroundColor: "rgba(75, 192, 192, 1)",
        pointHoverBorderColor: "rgba(220,220,220,1)",
        tension: 0.4,
      },
    ],
  };

  return (
    <div>
      <Line
        data={chartData}
        options={{
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: "Number of Users Over Time",
              font: {
                size: 25,
              },
            },
            tooltip: {
              mode: "index",
              intersect: false,
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              titleFont: { size: 16 },
              bodyFont: { size: 14 },
            },
          },
          scales: {
            x: {
              grid: {
                display: true,
                color: "rgba(0, 0, 0, 0.1)",
              },
              ticks: {
                font: { size: 14 },
              },
            },
            y: {
              grid: {
                display: true,
                color: "rgba(0, 0, 0, 0.1)",
              },
              ticks: {
                font: { size: 14 },
              },
            },
          },
          animation: {
            duration: 1500,
          },
        }}
      />
    </div>
  );
};

const animationClasses = {
  enter: "fade-enter",
  enterActive: "fade-enter-active",
  exit: "fade-exit",
  exitActive: "fade-exit-active",
};

const animationStyles = `
  .fade-enter {
    opacity: 0;
    transform: scale(0.9);
  }
  .fade-enter-active {
    opacity: 1;
    transform: scale(1);
    transition: opacity 300ms, transform 300ms;
  }
  .fade-exit {
    opacity: 1;
    transform: scale(1);
  }
  .fade-exit-active {
    opacity: 0;
    transform: scale(0.9);
    transition: opacity 300ms, transform 300ms;
  }
`;

// Add the animation styles to the head of the document
const style = document.createElement("style");
style.innerHTML = animationStyles;
document.head.appendChild(style);

class AdminDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      filterDate: "",
      filterName: "",
      totalusers: 0,
      activeUsersCount: 0,
      inactiveUsersCount: 0,
      totalApplicants: 0,
      totalInterviews: 0,
      totalJobOpenings: 0,
      totalTechnicalConsultants: 0,
      totalBusinessOpportunities: 0,
      appliedCount: 0,
      underReviewCount: 0,
      interviewScheduledCount: 0,
      selectedCount: 0,
      rejectedCount: 0,
      interviewercount: 0,
      hrcount: 0,
      candidatecount: 0,
      admincount: 0,
      monthlyUserCounts: [],
      user_list: [],
      applicant_list: [],
      jobopening_list: [],
      interview_scheduled_list: [],
      Hr_list: [],
      Interviewer_list: [],
      showDateInput: false,
      showNameInput: false,
      filterDate1: "",
      showDateInput1: false,
      filterDate2: "",
      filterName2: "",
      showDateInput2: false,
      showNameInput2: false,
      pageCount: 0,
      userCurrentPage: 1,
      userItemsPerPage: 3,
      interviewCurrentPage: 1,
      interviewItemsPerPage: 3,
      jobOpeningCurrentPage: 1,
      jobOpeningItemsPerPage: 3,
      startDate: null,
      endDate: null,
      startDate2: null,
      endDate2: null,
      Personality_score: [],
      editModalVisible: false,
      formData: {
        job_id: "",
        jobtitle: "",
        description: "",
        vacancies: "",
        experience: "",
        job_location: "",
        role_type: "",
      },
      // New states for letter counts
      letterSummary: {
        total_letters: 0,
        offer_letters_count: 0,
        appointment_letters_count: 0,
        total_sent: 0,
        total_not_sent: 0
      },
      offerLettersData: {
        total: 0,
        sent: 0,
        not_sent: 0
      },
      appointmentLettersData: {
        total: 0,
        sent: 0,
        not_sent: 0
      }
    };
    this.traitOptions = [
      { value: "neuroticism", label: "Neuroticism" },
      { value: "conscientiousness", label: "Conscientiousness" },
      { value: "openness", label: "Openness" },
      { value: "extraversion", label: "Extraversion" },
      { value: "agreeableness", label: "Agreeableness" },
    ];
    this.selectedTrait = "";
  }

  componentDidMount() {
    this.fetchTotalApplicants();
    this.fetchTotalInterviews();
    this.fetchTotalJobOpenings();
    this.fetchJobApplicationStatusCounts();
    this.fetchTotalUsers();
    this.fetchTotalAccountStatus();
    this.fetchrolecount();
    this.userline();
    this.fetchUserList();
    this.applicantList();
    this.jobopeninglist();
    this.interview_scheduled_list();
    this.Hr_list();
    this.Interviewer_list();
    this.Personality_score();
    this.fetchJobPostingStatus();
    this.fetchLetterDetails(); // Fetch letter details
  }

  // New method to fetch letter details
  fetchLetterDetails = () => {
    this.setState({ isLoading: true });
    axios
      .get("https://raasbackend.vetrinahealthcare.com/get_letter_details/")
      .then((response) => {
        const data = response.data;
        this.setState({
          letterSummary: data.summary,
          offerLettersData: data.offer_letters,
          appointmentLettersData: data.appointment_letters,
          isLoading: false
        });
      })
      .catch((error) => {
        console.error("Error fetching letter details:", error);
        this.setState({ isLoading: false });
      });
  };

  fetchJobPostingStatus() {
    axios
      .get("https://raasbackend.vetrinahealthcare.com/JobPostingresultByStatus/")
      .then((response) => {
        this.setState({
          totalTechnicalConsultants:
            response.data.technical_consultants.length,
          totalBusinessOpportunities:
            response.data.business_opportunities.length,
        });
      })
      .catch((error) => {
        console.error("Error fetching job posting status:", error);
      });
  }

  Personality_score = () => {
    axios
      .get("https://raasbackend.vetrinahealthcare.com/personality_list/")
      .then((response) => {
        const Personality_score = response.data;
        const filteredData = Personality_score.filter((item) => {
          return (
            item.max_personality.includes("neuroticism") ||
            item.max_personality.includes("conscientiousness") ||
            item.max_personality.includes("openness") ||
            item.max_personality.includes("extraversion") ||
            item.max_personality.includes("agreeableness")
          );
        });
        this.setState({ Personality_score, filteredData });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  Interviewer_list() {
    axios
      .get("https://raasbackend.vetrinahealthcare.com/Interviewer_list/")
      .then((response) => {
        const Interviewer_list = response.data;
        this.setState({ Interviewer_list });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  Hr_list() {
    axios
      .get("https://raasbackend.vetrinahealthcare.com/HR_list/")
      .then((response) => {
        const Hr_list = response.data;
        this.setState({ Hr_list });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  interview_scheduled_list() {
    axios
      .get("https://raasbackend.vetrinahealthcare.com/get_interview_list/")
      .then((response) => {
        const interview_scheduled_list = response.data;
        this.setState({ interview_scheduled_list });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  fetchUserList() {
    axios
      .get("https://raasbackend.vetrinahealthcare.com/list_users/")
      .then((response) => {
        const user_list = response.data;
        this.setState({ user_list });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  applicantList() {
    axios
      .get("https://raasbackend.vetrinahealthcare.com/get_applicant_names/")
      .then((response) => {
        const applicant_list = response.data;
        this.setState({ applicant_list });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  jobopeninglist() {
    axios
      .get("https://raasbackend.vetrinahealthcare.com/job_opening_list/")
      .then((response) => {
        const rawJobOpenings = response.data;
        const sortedJobOpenings = [...rawJobOpenings].sort((a, b) => {
          if (a.job_id < b.job_id) return -1;
          if (a.job_id > b.job_id) return 1;
          return 0;
        });
        this.setState({ jobopening_list: sortedJobOpenings });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  userline() {
    axios
      .get("https://raasbackend.vetrinahealthcare.com/get_user_count_data/")
      .then((response) => {
        const monthlyUserCounts = response.data.user_counts;
        this.setState({ monthlyUserCounts });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  fetchJobApplicationStatusCounts() {
    fetch(
      "https://raasbackend.vetrinahealthcare.com/job_application_status_counts/"
    )
      .then((response) => response.json())
      .then((data) => {
        const {
          Applied,
          under_review,
          interview_scheduled,
          selected,
          rejected,
        } = data.status_counts;
        this.setState({
          appliedCount: Applied || 0,
          underReviewCount: under_review || 0,
          interviewScheduledCount: interview_scheduled || 0,
          selectedCount: selected || 0,
          rejectedCount: rejected || 0,
        });
      })
      .catch((error) => {
        console.error("Error fetching job application status counts:", error);
      });
  }

  fetchrolecount() {
    fetch("https://raasbackend.vetrinahealthcare.com/get_role_count/")
      .then((response) => response.json())
      .then((data) => {
        const { Candidate, Interviewer, HR, Admin } = data.status_counts;
        this.setState({
          candidatecount: Candidate,
          interviewercount: Interviewer || 0,
          hrcount: HR || 0,
          admincount: Admin || 0,
        });
      })
      .catch((error) => {
        console.error("Error fetching job application status counts:", error);
      });
  }

  fetchTotalJobOpenings() {
    fetch("https://raasbackend.vetrinahealthcare.com/total_job_openings/")
      .then((response) => response.json())
      .then((data) => {
        this.setState({ totalJobOpenings: data.total_job_openings });
      })
      .catch((error) => {
        console.error("Error fetching total job openings:", error);
      });
  }

  fetchTotalApplicants() {
    this.setState({ isLoading: true });
    fetch("https://raasbackend.vetrinahealthcare.com/total_applicants/")
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          totalApplicants: data.total_applicants,
          isLoading: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching total applicants:", error);
      });
  }

  fetchTotalInterviews() {
    fetch("https://raasbackend.vetrinahealthcare.com/interviews/")
      .then((response) => response.json())
      .then((data) => {
        this.setState({ totalInterviews: data.length });
      })
      .catch((error) => {
        console.error("Error fetching total interviews:", error);
      });
  }

  fetchTotalUsers() {
    this.setState({ isLoading: true });
    fetch("https://raasbackend.vetrinahealthcare.com/total_users/")
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          totalusers: data.total_users,
          isLoading: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching total Users:", error);
        this.setState({ isLoading: false });
      });
  }

  fetchTotalAccountStatus() {
    fetch("https://raasbackend.vetrinahealthcare.com/total_account_status/")
      .then((response) => response.json())
      .then((data) => {
        const { active_users, inactive_users } = data;
        this.setState({
          activeUsersCount: active_users,
          inactiveUsersCount: inactive_users,
        });
      })
      .catch((error) => {
        console.error("Error fetching total Users:", error);
      });
  }

  // Rest of your existing methods...
  filterByDate = () => {
    const { user_list, startDate, endDate } = this.state;
    return user_list.filter((user) => {
      const createdAt = moment(user.created_at, "DD/MM/YYYY");
      if (startDate && endDate) {
        return createdAt.isBetween(startDate, endDate, null, "[]");
      } else if (startDate) {
        return createdAt.isSameOrAfter(startDate, "day");
      } else if (endDate) {
        return createdAt.isSameOrBefore(endDate, "day");
      }
      return true;
    });
  };

  handleStartDateChange = (date) => {
    this.setState({ startDate: date });
  };

  handleEndDateChange = (date) => {
    this.setState({ endDate: date });
  };

  filterByName = () => {
    const { user_list, filterName } = this.state;
    return user_list.filter((user) =>
      user.name.toLowerCase().includes(filterName.toLowerCase())
    );
  };

  handleDateChange = (e) => {
    this.setState({ filterDate: e.target.value });
  };

  handleNameChange = (e) => {
    this.setState({ filterName: e.target.value });
  };

  toggleDateInput = () => {
    this.setState((prevState) => ({
      showDateInput: !prevState.showDateInput,
    }));
  };

  toggleNameInput = () => {
    this.setState((prevState) => ({
      showNameInput: !prevState.showNameInput,
    }));
  };

  filterByDate1 = () => {
    const { interview_scheduled_list, filterDate1 } = this.state;
    return interview_scheduled_list.filter((interview) =>
      interview.date.includes(filterDate1)
    );
  };

  handleDateChange1 = (e) => {
    this.setState({ filterDate1: e.target.value });
  };

  toggleDateInput1 = () => {
    this.setState((prevState) => ({
      showDateInput1: !prevState.showDateInput1,
    }));
  };

  filterByDate2 = () => {
    const { jobopening_list, startDate2, endDate2 } = this.state;
    return jobopening_list.filter((user) => {
      const createdAt = moment(user.created_at, "DD/MM/YYYY");
      if (startDate2 && endDate2) {
        return createdAt.isBetween(startDate2, endDate2, null, "[]");
      } else if (startDate2) {
        return createdAt.isSameOrAfter(startDate2, "day");
      } else if (endDate2) {
        return createdAt.isSameOrBefore(endDate2, "day");
      }
      return true;
    });
  };

  handleStartDateChange2 = (date) => {
    this.setState({ startDate2: date });
  };

  handleEndDateChange2 = (date) => {
    this.setState({ endDate2: date });
  };

  filterByName2 = () => {
    const { jobopening_list, filterName2 } = this.state;
    return jobopening_list.filter((user) =>
      user.jobtitle.toLowerCase().includes(filterName2.toLowerCase())
    );
  };

  handleDateChange2 = (e) => {
    this.setState({ filterDate2: e.target.value });
  };

  handleNameChange2 = (e) => {
    this.setState({ filterName2: e.target.value });
  };

  toggleDateInput2 = () => {
    this.setState((prevState) => ({
      showDateInput2: !prevState.showDateInput2,
    }));
  };

  toggleNameInput2 = () => {
    this.setState((prevState) => ({
      showNameInput2: !prevState.showNameInput2,
    }));
  };

  handleTraitChange = (event) => {
    this.selectedTrait = event.target.value;
    const filteredData = this.state.Personality_score.filter((item) => {
      return item.max_personality.includes(this.selectedTrait);
    });
    this.setState({ filteredData });
  };

  handleUserPageChange = (page) => {
    this.setState({ userCurrentPage: page });
  };

  handleInterviewPageChange = (page) => {
    this.setState({ interviewCurrentPage: page });
  };

  handleJobOpeningPageChange = (page) => {
    this.setState({ jobOpeningCurrentPage: page });
  };

  editJobOpening = (jobId) => {
    fetch(`https://raasbackend.vetrinahealthcare.com/get_job_posting/${jobId}/`)
      .then((response) => response.json())
      .then((data) => {
        const obj = {
          job_id: data.job_id,
          jobtitle: data.jobtitle,
          description: data.description,
          vacancies: data.vacancies,
          experience: data.experience,
          job_location: data.job_location,
          role_type: data.role_type,
        };
        this.UpdateFormData(obj);
      })
      .catch((error) => console.error("Error fetching job posting:", error));
  };

  UpdateFormData = (obj) => {
    this.setState({
      formData: obj,
      editModalVisible: true,
    });
  };

  deleteJobOpening(jobId) {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this job opening?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(
            `https://raasbackend.vetrinahealthcare.com/job_opening/${jobId}/`
          )
          .then((response) => {
            console.log("Delete successful:", response.data.message);
            this.setState((prevState) => ({
              jobopening_list: prevState.jobopening_list.filter(
                (job) => job.job_id !== jobId
              ),
            }));
            Swal.fire(
              "Deleted!",
              response.data.message || "The job opening has been deleted.",
              "success"
            );
          })
          .catch((error) => {
            console.error("Error deleting job opening:", error);
            let errorMessage =
              "Failed to delete the job opening. Please try again.";
            if (error.response && error.response.data) {
              if (error.response.data.error) {
                errorMessage = error.response.data.error;
              } else if (error.response.data.message) {
                errorMessage = error.response.data.message;
              }
            } else if (error.message) {
              errorMessage = error.message;
            }
            Swal.fire("Failed!", errorMessage, "error");
          });
      }
    });
  }

  submitEditJobForm = () => {
    const { formData } = this.state;
    const jobDetails = {
      jobtitle: formData.jobtitle,
      description: formData.description,
      vacancies: formData.vacancies,
      experience: formData.experience,
      job_location: formData.job_location,
      role_type: formData.role_type,
    };

    fetch(
      `https://raasbackend.vetrinahealthcare.com/update_job_posting/${formData.job_id}/`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(jobDetails),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.error_message) {
          console.error("Error updating job posting:", data.error_message);
        } else {
          console.log("Job posting updated successfully");
          this.setState({ editModalVisible: false });
        }
      })
      .catch((error) => console.error("Error updating job posting:", error));
  };

  handleInputChange = (e) => {
    const { id, value } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [id.replace("edit-", "")]: value,
      },
    }));
  };

  render() {
    const { isLoading } = this.state;

    const { editModalVisible, formData } = this.state;
    const { filterDate, filterName, showDateInput, showNameInput, user_list } =
      this.state;
    const { filterDate1, showDateInput1 } = this.state;
    const { filterDate2, showDateInput2, filterName2, showNameInput2 } =
      this.state;
    const { endDate, startDate } = this.state;
    const { endDate2, startDate2 } = this.state;
    const filteredJobOpenings = this.filterByDate2().filter((user) =>
      this.filterByName2().includes(user)
    );
    const filteredInterviews = this.filterByDate1();
    const filteredUsers = this.filterByDate().filter((user) =>
      this.filterByName().includes(user)
    );
    const { userCurrentPage, userItemsPerPage } = this.state;
    const { interviewCurrentPage, interviewItemsPerPage } = this.state;
    const { jobOpeningCurrentPage, jobOpeningItemsPerPage } = this.state;

    const userIndexOfLastItem = userCurrentPage * userItemsPerPage;
    const userIndexOfFirstItem = userIndexOfLastItem - userItemsPerPage;
    const currentUserItems = filteredUsers.slice(
      userIndexOfFirstItem,
      userIndexOfLastItem
    );

    const interviewIndexOfLastItem =
      interviewCurrentPage * interviewItemsPerPage;
    const interviewIndexOfFirstItem =
      interviewIndexOfLastItem - interviewItemsPerPage;
    const currentInterviewItems = filteredInterviews.slice(
      interviewIndexOfFirstItem,
      interviewIndexOfLastItem
    );

    const jobOpeningIndexOfLastItem =
      jobOpeningCurrentPage * jobOpeningItemsPerPage;
    const jobOpeningIndexOfFirstItem =
      jobOpeningIndexOfLastItem - jobOpeningItemsPerPage;
    const currentJobOpeningItems = filteredJobOpenings.slice(
      jobOpeningIndexOfFirstItem,
      jobOpeningIndexOfLastItem
    );

    const {
      totalusers,
      totalApplicants,
      totalInterviews,
      totalJobOpenings,
      totalTechnicalConsultants,
      totalBusinessOpportunities,
      appliedCount,
      underReviewCount,
      interviewScheduledCount,
      selectedCount,
      rejectedCount,
      hrcount,
      candidatecount,
      interviewercount,
      admincount,
      activeUsersCount,
      inactiveUsersCount,
      letterSummary,
      offerLettersData,
      appointmentLettersData
    } = this.state;
    
    const pieChartData = [
      { name: "Under Review", value: underReviewCount },
      { name: "Selected", value: selectedCount },
      { name: "Rejected", value: rejectedCount },
      { name: "Interview Scheduled", value: interviewScheduledCount },
      { name: "Applied", value: appliedCount },
    ];

    const COLORS = ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"];
    const options = {
      animationEnabled: true,
      backgroundColor: "#ffffff",
      data: [
        {
          type: "doughnut",
          showInLegend: true,
          dataPoints: [
            { color: "#9966FF", name: "Applied", y: appliedCount },
            { color: "#3399CC", name: "Selected", y: selectedCount },
            { color: "#FFCC66", name: "Rejected", y: rejectedCount },
            { color: "#ff6384", name: "Under Review", y: underReviewCount },
            {
              color: "#4bc0c0",
              name: "Interview Scheduled",
              y: interviewScheduledCount,
            },
          ],
        },
      ],
    };

    const { monthlyUserCounts } = this.state;
    let monthCounts = Array.from({ length: 12 }, () => 0);

    monthlyUserCounts.forEach((entry) => {
      const monthIndex = entry.month - 1;
      monthCounts[monthIndex] = entry.count;
    });

    const getMonthName = (month) => {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return months[month];
    };

    const dataPoints = monthCounts.map((count, index) => ({
      label: getMonthName(index),
      y: count,
    }));

    const data = {
      animationEnabled: true,
      interactivityEnabled: true,
      responsive: true,
      height: 300,
      backgroundColor: "#ffffff",
      axisX: {
        title: "Months",
        valueFormatString: "MMM",
        interval: 1,
      },
      axisY: {
        title: "User Count",
      },
      data: [
        {
          lineColor: " #C51EB7",
          type: "spline",
          dataPoints: dataPoints,
        },
      ],
      animation: {
        duration: 2000,
      },
    };

    const columns = [
      {
        name: (
          <h6>
            <b>Name</b>
          </h6>
        ),
        selector: "name",
        format: (row) => row.name,
      },
      {
        name: (
          <h6>
            <b>Date</b>
          </h6>
        ),
        selector: "created_at",
        format: (row) => row.created_at.slice(0, 10),
      },
      {
        name: (
          <h6>
            <b>Profile Completed</b>
          </h6>
        ),
        selector: "status",
        format: (row) => row.status,
      },
    ];

    const columns_job = [
      {
        name: (
          <h6>
            <b>Job ID</b>
          </h6>
        ),
        selector: "job_id",
        format: (row) => row.job_id,
      },
      {
        name: (
          <h6>
            <b>Date</b>
          </h6>
        ),
        selector: "created_at",
        format: (row) => row.created_at.slice(0, 10),
      },
      {
        name: (
          <h6>
            <b>Job Title</b>
          </h6>
        ),
        selector: "jobtitle",
        format: (row) => row.jobtitle,
      },
      {
        name: (
          <h6>
            <b>Action</b>
          </h6>
        ),
        cell: (row) => (
          <div>
            <button
              className="btn btn-warning"
              onClick={() =>
                this.editJobOpening(row.job_id, this.UpdateFormData)
              }
              style={{ marginRight: "5px" }}
            >
              <i className="fa-solid fa-edit" />
            </button>
            <button
              className="btn btn-danger"
              onClick={() => this.deleteJobOpening(row.job_id)}
            >
              <i className="fa-solid fa-trash" />
            </button>
          </div>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
    ];

    const columns_personality = [
      {
        name: (
          <h6>
            <b>Applicant Name</b>
          </h6>
        ),
        selector: "name",
        format: (item) => item.name,
      },
      {
        name: (
          <h6>
            <b>Personality Test Result</b>
          </h6>
        ),
        selector: "created_at",
        format: (item) => item.max_personality.join(", "),
      },
    ];

    const paginatedUsers = currentUserItems.slice(
      (userCurrentPage - 1) * userItemsPerPage,
      userCurrentPage * userItemsPerPage
    );
    
    return (
      <>
        <DashNavbar />
        <div className="wrapper">
          <Sidebar />
          <div className="main">
            {/* First Row: 6 Cards */}
            <div className="mt-3 d-flex flex-wrap justify-content-start">
              {/* Card 1: Users */}
              <div className="card-body admin ab">
                <h5 className="card-title headline">Users</h5>
                <div className="info-icon">
                  <FiUsers style={{ color: "#ffffff", fontSize: "2em" }} />
                </div>
                <p className="card-text score display-5">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    totalusers
                  )}
                </p>
              </div>

              {/* Card 2: Applicants */}
              <div className="card-body admin ab">
                <h5 className="card-title headline">Applicants</h5>
                <div className="info-icon">
                  <ImUserTie style={{ color: "#ffffff", fontSize: "2em" }} />
                </div>
                <p className="card-text score display-5">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    totalApplicants
                  )}
                </p>
              </div>

              {/* Card 3: Interviews Scheduled */}
              {/* <div className="card-body admin ab">
                <h5 className="card-title headline">Interviews Scheduled</h5>
                <div className="info-icon">
                  <AiOutlineSchedule style={{ color: "#ffffff", fontSize: "2em" }} />
                </div>
                <p className="card-text score display-5">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    totalInterviews
                  )}
                </p>
              </div> */}

              {/* Card 4: Job Openings */}
              <div className="card-body admin ab">
                <h5 className="card-title headline">Job Openings</h5>
                <div className="info-icon">
                  <MdWork style={{ color: "#ffffff", fontSize: "2em" }} />
                </div>
                <p className="card-text score display-5">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    totalJobOpenings
                  )}
                </p>
              </div>

              {/* Card 5: Technical Consultant */}
              <div className="card-body admin ab">
                <h5 className="card-title headline">Technical Consultant</h5>
                <div className="info-icon">
                  <FaHardHat style={{ color: "#ffffff", fontSize: "2em" }} />
                </div>
                <p className="card-text score display-5">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    totalTechnicalConsultants
                  )}
                </p>
              </div>

              {/* Card 6: Business Opportunities */}
              <div className="card-body admin ab">
                <h5 className="card-title headline">Business Opportunities</h5>
                <div className="info-icon">
                  <FaBriefcase style={{ color: "#ffffff", fontSize: "2em" }} />
                </div>
                <p className="card-text score display-5">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    totalBusinessOpportunities
                  )}
                </p>
              </div>
            </div>

            {/* Second Row: 6 Cards */}
            <div className="mt-3 d-flex flex-wrap justify-content-start">
              {/* Card 7: HR Count */}
              <div className="card-body hr">
                <h5 className="card-title headline">HR</h5>
                <div className="info-icon">
                  <FaChalkboardUser style={{ color: "#ffffff", fontSize: "2em" }} />
                </div>
                <p className="card-text score display-5">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    hrcount
                  )}
                </p>
              </div>

              {/* Card 8: Interviewers */}
              <div className="card-body hr">
                <h5 className="card-title headline">Interviewers</h5>
                <div className="info-icon">
                  <FaUserTie style={{ color: "#ffffff", fontSize: "2em" }} />
                </div>
                <p className="card-text score display-5">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    interviewercount
                  )}
                </p>
              </div>

              {/* Card 9: Candidates */}
              <div className="card-body hr">
                <h5 className="card-title headline">Candidates</h5>
                <div className="info-icon">
                  <HiMiniUserGroup style={{ color: "#ffffff", fontSize: "2em" }} />
                </div>
                <p className="card-text score display-5">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    candidatecount
                  )}
                </p>
              </div>

              {/* Card 10: Active Users */}
              {/* <div className="card-body hr">
                <h5 className="card-title headline">Active Users</h5>
                <div className="info-icon">
                  <FaUserCheck style={{ color: "#ffffff", fontSize: "2em" }} />
                </div>
                <p className="card-text score display-5">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    activeUsersCount
                  )}
                </p>
              </div> */}

              {/* Card 11: Offer Letters */}
              <div className="card-body hr">
                <h5 className="card-title headline">Offer Letters</h5>
                <div className="info-icon">
                  <FaEnvelope style={{ color: "#ffffff", fontSize: "2em" }} />
                </div>
                <p className="card-text score display-5">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    letterSummary.offer_letters_count
                  )}
                </p>
              </div>

              {/* Card 12: Appointment Letters */}
              <div className="card-body hr">
                <h5 className="card-title headline">Appointment Letters</h5>
                <div className="info-icon">
                  <FaFileContract style={{ color: "#ffffff", fontSize: "2em" }} />
                </div>
                <p className="card-text score display-5">
                  {isLoading ? (
                    <div className="loader-container">
                      <ClipLoader color="#ffffff" size={30} />
                    </div>
                  ) : (
                    letterSummary.appointment_letters_count
                  )}
                </p>
              </div>
            </div>

            {/* Rest of your existing code... */}
            <div className="row mt-2">
              <div className="col-lg-6">
                <div className="d-flex flex-wrap justify-content-start">
                  <div className="card-body1 candidate applied">
                    <h5 className="card-title headline1">Applied</h5>
                    <p className="card-text score display-5">
                      {isLoading ? (
                        <div className="loader-container">
                          <ClipLoader color="#ffffff" size={30} />
                        </div>
                      ) : (
                        appliedCount
                      )}
                    </p>
                  </div>
                  
                  <div className="card-body1 candidate review">
                    <h5 className="card-title headline1">Under Review</h5>
                    <p className="card-text score display-5">
                      {isLoading ? (
                        <div className="loader-container">
                          <ClipLoader color="#ffffff" size={30} />
                        </div>
                      ) : (
                        underReviewCount
                      )}
                    </p>
                  </div>
                  
                  <div className="card-body1 candidate interview">
                    <h5 className="card-title headline1">Interview Scheduled</h5>
                    <p className="card-text score display-5">
                      {isLoading ? (
                        <div className="loader-container">
                          <ClipLoader color="#ffffff" size={30} />
                        </div>
                      ) : (
                        interviewScheduledCount
                      )}
                    </p>
                  </div>
                  
                  <div className="card-body1 candidate selected">
                    <h5 className="card-title headline1">Selected</h5>
                    <p className="card-text score display-5">
                      {isLoading ? (
                        <div className="loader-container">
                          <ClipLoader color="#ffffff" size={30} />
                        </div>
                      ) : (
                        selectedCount
                      )}
                    </p>
                  </div>
                  
                  <div className="card-body1 candidate rejected">
                    <h5 className="card-title headline1">Rejected</h5>
                    <p className="card-text score display-5">
                      {isLoading ? (
                        <div className="loader-container">
                          <ClipLoader color="#ffffff" size={30} />
                        </div>
                      ) : (
                        rejectedCount
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="container-fluid m-3">
                  <CanvasJSChart options={options} />
                </div>
              </div>
            </div>
            
            {/* Rest of your existing DataTable and other components */}
            <div className="container-fluid">
              <div className="row mt-2">
                <div className="d-flex flex-md-row flex-column justify-content-between align-items-center w-100">
                  <h2 className="mb-0">Candidates List</h2>
                  <div className="d-flex flex-md-row flex-column align-items-end mt-md-0 mt-3">
                    <div className="form-group mb-3 me-md-2">
                      <div className="input-group">
                        <DatePicker
                          selected={startDate}
                          onChange={this.handleStartDateChange}
                          selectsStart
                          startDate={startDate}
                          endDate={endDate}
                          placeholderText="Start Date"
                          className="form-control startdate"
                          dateFormat="dd-MM-yyyy"
                        />
                      </div>
                    </div>
                    <div className="form-group mb-3 me-md-2">
                      <div className="input-group">
                        <DatePicker
                          selected={endDate}
                          onChange={this.handleEndDateChange}
                          selectsEnd
                          startDate={startDate}
                          endDate={endDate}
                          minDate={startDate}
                          placeholderText="End Date"
                          className="form-control enddate"
                          dateFormat="dd-MM-yyyy"
                        />
                      </div>
                    </div>
                    <div className="form-group mb-3 me-md-2">
                      <div className="input-group">
                        <input
                          type="search"
                          className="form-control enddate"
                          placeholder="Enter Candidate Name"
                          value={filterName}
                          onChange={this.handleNameChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <DataTable
                  columns={columns}
                  data={filteredUsers}
                  pagination
                  paginationPerPage={userItemsPerPage}
                  paginationRowsPerPageOptions={[3, 5, 10, 15]}
                  paginationComponentOptions={{
                    rowsPerPageText: "Rows per page:",
                  }}
                  paginationTotalRows={filteredUsers.length}
                  onChangePage={this.handleUserPageChange}
                />
              </div>

              <div className="row mt-2">
                <div className="d-flex flex-md-row flex-column justify-content-between align-items-center w-100">
                  <h2 className="mb-0">Job Opening List</h2>
                  <div className="d-flex flex-md-row flex-column align-items-end mt-md-0 mt-3">
                    <div className="form-group mb-3 me-md-2">
                      <div className="input-group">
                        <DatePicker
                          selected={startDate2}
                          onChange={this.handleStartDateChange2}
                          selectsStart
                          startDate={startDate2}
                          endDate={endDate2}
                          placeholderText="Start Date"
                          className="form-control startdate"
                          dateFormat="dd-MM-yyyy"
                        />
                      </div>
                    </div>
                    <div className="form-group mb-3 me-md-2">
                      <div className="input-group">
                        <DatePicker
                          selected={endDate2}
                          onChange={this.handleEndDateChange2}
                          selectsEnd
                          startDate={startDate2}
                          endDate={endDate2}
                          minDate={startDate2}
                          placeholderText="End Date"
                          className="form-control enddate"
                          dateFormat="dd-MM-yyyy"
                        />
                      </div>
                    </div>
                    <div className="form-group mb-3 me-md-2">
                      <div className="input-group">
                        <input
                          type="search"
                          className="form-control enddate"
                          placeholder="Enter Candidate Name"
                          value={filterName2}
                          onChange={this.handleNameChange2}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <DataTable
                  columns={columns_job}
                  data={filteredJobOpenings}
                  pagination
                  paginationPerPage={userItemsPerPage}
                  paginationRowsPerPageOptions={[3, 5, 10, 15]}
                  paginationComponentOptions={{
                    rowsPerPageText: "Rows per page:",
                  }}
                  paginationTotalRows={filteredJobOpenings.length}
                  onChangePage={this.handleUserPageChange}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Edit Job Modal */}
        <CSSTransition
          in={editModalVisible}
          timeout={300}
          classNames={animationClasses}
          unmountOnExit
        >
          <Modal
            show={editModalVisible}
            onHide={() => this.setState({ editModalVisible: false })}
          >
            <Modal.Header closeButton>
              <Modal.Title>Edit Job Posting</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form id="editJobForm">
                <input type="hidden" id="edit-job-id" value={formData.job_id} />
                <div className="form-group">
                  <label>Job Title</label>
                  <input
                    type="text"
                    id="edit-jobtitle"
                    className="form-control"
                    value={formData.jobtitle}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    id="edit-description"
                    className="form-control"
                    value={formData.description}
                    onChange={this.handleInputChange}
                  ></textarea>
                </div>
                <div className="form-group">
                  <label>Vacancies</label>
                  <input
                    type="number"
                    id="edit-vacancies"
                    className="form-control"
                    value={formData.vacancies}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label>Experience</label>
                  <input
                    type="text"
                    id="edit-experience"
                    className="form-control"
                    value={formData.experience}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label>Job Location</label>
                  <input
                    type="text"
                    id="edit-job_location"
                    className="form-control"
                    value={formData.job_location}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label>Role Type</label>
                  <input
                    type="text"
                    id="edit-role_type"
                    className="form-control"
                    value={formData.role_type}
                    onChange={this.handleInputChange}
                  />
                </div>
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={this.submitEditJobForm}>
                Update
              </Button>
              <Button
                variant="secondary"
                onClick={() => this.setState({ editModalVisible: false })}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        </CSSTransition>
      </>
    );
  }
}

export default AdminDashboard;